import React from "react";
import dayjs from "dayjs";
import { Box, Stack, Tag, Icon } from "@chakra-ui/react";
import { MdAcUnit, MdWarningAmber, MdCalendarToday } from "react-icons/md";
import InfoRow from "../shared/InfoRow";

/**
 * Renders a warning banner when the wallet is frozen.
 * @param {Object} props
 * @param {Object} props.wallet - Wallet data with frozen, frozen_reason, frozen_at
 * @param {boolean} props.isMobile - Whether the viewport is mobile-sized
 * @returns {React.ReactElement}
 */
function FrozenBanner({ wallet, isMobile }) {
    return (
        <Box
            mb={6}
            padding={isMobile ? 4 : 5}
            background="rgba(244, 67, 54, 0.1)"
            borderRadius="8px"
            border="1px solid rgba(244, 67, 54, 0.3)"
        >
            <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                <Icon as={MdAcUnit} color="#f44336" boxSize={isMobile ? "18px" : "20px"} />
                <Tag
                    size="sm"
                    background="rgba(244, 67, 54, 0.2)"
                    color="#f44336"
                    border="1px solid rgba(244, 67, 54, 0.4)"
                    fontWeight={600}
                    fontSize={isMobile ? "0.65rem" : "0.7rem"}
                >
                    Frozen wallet
                </Tag>
            </Stack>
            <InfoRow
                icon={MdWarningAmber}
                label="Reason"
                value={wallet?.frozen_reason || "Not specified"}
                color="#f44336"
                isMobile={isMobile}
            />
            <FrozenDateRow wallet={wallet} isMobile={isMobile} />
        </Box>
    );
}

/**
 * Renders the frozen date row if the wallet has a frozen_at timestamp.
 * @param {Object} props
 * @param {Object} props.wallet - Wallet data with frozen_at
 * @param {boolean} props.isMobile - Whether the viewport is mobile-sized
 * @returns {React.ReactElement|null}
 */
function FrozenDateRow({ wallet, isMobile }) {
    if (!wallet?.frozen_at) return null;

    return (
        <Box mt={2}>
            <InfoRow
                icon={MdCalendarToday}
                label="Frozen on"
                value={dayjs(wallet.frozen_at).format("DD/MM/YYYY HH:mm")}
                color="rgba(244, 67, 54, 0.8)"
                isMobile={isMobile}
            />
        </Box>
    );
}

export default FrozenBanner;
